import { render, staticRenderFns } from "./LoginPassCode.vue?vue&type=template&id=6fbc0ae1&scoped=true&"
import script from "./LoginPassCode.vue?vue&type=script&lang=js&"
export * from "./LoginPassCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc0ae1",
  null
  
)

export default component.exports